import React, { useState } from 'react';
import { Box, Card, CardHeader, IconButton, Typography } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Color } from '../../types';
import { usePositionData } from '../../hooks';
import PositionMenu from './components/PositionMenu';
import { useAppSelector } from 'src/redux/hooks';
import { userSelectors } from 'src/redux/user';

interface IProps {
  color?: Color;
  isInSideBar?: boolean;
}

export const PositionLink: React.FC<IProps> = ({
  color = Color.INVERTED,
  isInSideBar,
}) => {
  const positionData = usePositionData();
  const userData = useAppSelector(userSelectors.getUserData);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const isOpen = Boolean(anchorEl);

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {!userData?.profileSubmittedAt &&
      positionData !== null &&
      positionData.isDisplayable !== false ? (
        <Card elevation={0}>
          <CardHeader
            disableTypography
            title={
              <>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                  }}
                >
                  <Typography
                    variant="body2"
                    color={
                      color === Color.INVERTED
                        ? 'text.invertedSecondary'
                        : 'text.secondary'
                    }
                    fontWeight="500"
                    fontSize="0.8rem"
                    sx={{ ml: 2.5 }}
                  >
                    Applying for position
                  </Typography>
                  <IconButton
                    id="position-menu-button"
                    aria-controls="position-menu"
                    aria-haspopup="true"
                    aria-expanded={isOpen ? 'true' : undefined}
                    sx={{
                      color:
                        color === Color.INVERTED
                          ? 'common.white'
                          : 'common.black',
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                    }}
                    onClick={handleOpenMenu}
                  >
                    <MoreHorizIcon color="secondary" />
                  </IconButton>
                </Box>

                <Typography
                  variant="body1"
                  color={
                    color === Color.INVERTED
                      ? 'text.invertedPrimary'
                      : 'text.primary'
                  }
                  fontWeight="500"
                  lineHeight="130%"
                  sx={(theme) => ({
                    width: '100%',
                    mb: isInSideBar ? 4 : 1,
                    py: 1,
                    borderRadius: '4px',
                    px: 2.5,
                    backgroundColor:
                      color === Color.INVERTED
                        ? theme.palette.background.brandSecondary
                        : theme.palette.highlight.neutral,
                  })}
                >
                  {positionData?.title}
                </Typography>
              </>
            }
            sx={{
              py: 1.5,
              pr: 1,
              pl: 2.5,
              '& .MuiCardHeader-action': {
                alignSelf: 'center',
              },
            }}
          />
          <PositionMenu
            anchorEl={anchorEl}
            isOpen={isOpen}
            handleCloseMenu={handleCloseMenu}
            link={positionData.jobPostingUrl}
          />
        </Card>
      ) : null}
    </>
  );
};

export default PositionLink;
